<template>
  <div v-if="show">
    <div class="mask">
      <div class="btnbox">
        <div class="btn" @click="download()">
          <svg-icon name="Download"></svg-icon>
        </div>
        <div class="btn" @click="show = false">
          <svg-icon name="MenuExpand"></svg-icon>
        </div>
      </div>
      <swiper
        ref="mySwiper"
        :options="{
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        }"
        @slide-change="handleSlideChange"
      >
        <swiper-slide v-for="(item, index) in imgList" :key="index">
          <div class="item">
            <img v-if="item" class="item-img" :src="item" alt="" />
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button swiper-button-prev" slot="button-prev">
        <svg-icon name="ChevronLeft" />
      </div>
      <div class="swiper-button swiper-button-next" slot="button-next">
        <svg-icon name="ChevronRight" />
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import SvgIcon from "@components/Icon/index.vue";
import "swiper/dist/css/swiper.css";
export default {
  name: "image-viewer",
  components: {
    swiper,
    swiperSlide,
    SvgIcon,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    list: {
      type: Array,
      required: true,
      default: [],
    },
    cur: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      imgList: [],
      activeIdx: 0,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    cur(val) {
      console.log(val);
      const list = this.adjustArrayPosition(this.list, val);
      this.imgList = list;
    },
  },
  methods: {
    handleSlideChange() {
      let {
        mySwiper: { swiper },
      } = this.$refs;
      this.activeIdx = swiper.realIndex;
    },
    adjustArrayPosition(array, targetIndex) {
      const arr1 = array.slice(0, targetIndex);
      const arr2 = array.slice(targetIndex, array.length);
      return [...arr2, ...arr1];
    },
    download() {
      const url = this.imgList[this.activeIdx];
      const a = document.createElement("a");
      a.style.display = "none";
      a.setAttribute("target", "_blank");
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // const url = this.imgList[this.activeIdx];
      // var xml = new XMLHttpRequest();
      // xml.open("GET", url, true);
      // xml.responseType = "blob";
      // xml.onload = function() {
      //   var url = window.URL.createObjectURL(xml.response);
      //   var a = document.createElement("a");
      //   a.href = url;
      //   document.body.appendChild(a);
      //   a.click();
      //   document.body.removeChild(a);
      // };
      // xml.send();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@style/base";
@import "@style/common";
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 10000;
  overflow: hidden;
  pointer-events: auto;
  display: flex;
  align-items: center;

  .btnbox {
    display: flex;
    align-items: center;
    position: fixed;
    top: 24px;
    right: 24px;
    z-index: 10;
    .btn {
      width: 48px;
      height: 48px;
      font-size: 24px;
      margin-left: 24px;
      border-radius: 50%;
      background-color: rgba(238, 238, 238, 0.6);
      backdrop-filter: blur(25px);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      @include media(
        (
          $md: (
            background-color: transparent,
            margin-left: 16px,
            right: 16px,
          ),
        )
      );
    }
  }
  .item {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    overflow: hidden;
    .item-img {
      width: 100vw;
      height: 100vh;
      object-position: center center;
      object-fit: contain;
      image-rendering: auto;
      @include media(
        (
          $md: (
            width: 100vw,
            height: auto,
            aspect-ratio: 1 / 1,
          ),
        )
      );
    }
  }

  .swiper-button {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(238, 238, 238, 0.6);
    font-size: 36px;
    &:hover {
      background-color: #131415;
      color: #fff;
    }
    @include media(
      (
        $md: (
          display: none,
        ),
      )
    );
  }
  .swiper-button-prev {
    left: 24px;
  }
  .swiper-button-next {
    right: 24px;
  }
}
</style>
